import { withMetadata } from '../metadata'
import { findNumbers as _findNumbers } from '../../core/index'

export function findNumbers() {
	return withMetadata(_findNumbers, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/findNumbers.js
// module id = 3MOf
// module chunks = 0 1